import React, { useEffect, useState } from 'react';
import { fetchProfile } from '../api/common';
import EditProfile from './EditProfile';
import UserAvatar from '../images/user.png';
import ill_lothes from '../images/ill-lothes-hanger-on2.png';
import EditIcon from '../components/EditIcon';
import BackIcon from '../components/BackIcon';
import { useAuth } from '../context/AuthContext';
function Profile() {
  const { user } = useAuth();
  const [profileData, setProfileData] = useState(null);
  const [edit, setEdit] = useState(false);

  const editProfile = () => {
    setEdit(true);
  };
  useEffect(() => {
    setProfileData({
      full_name: user?.full_name,
      email: user?.email,
      phone_number: user?.phone_number,
      dob: user?.dob,
      address_line_1: user?.address_line_1,
      address_line_2: user?.address_line_2,
      city: user?.city,
      state: user?.state,
      postal_code: user?.postal_code,
    });
  }, [user]);
  return (
    <>
      <div className="sm:flex sm:justify-between sm:items-center mb-8">
        {edit ? (
          <div className="btn">
            <BackIcon onClick={() => setEdit(false)} />
            <span className="ml-2 text-xl font-semibold text-portal-900">
              Complete Your Profile
            </span>
          </div>
        ) : (
          <span className="ml-2 text-xl font-semibold text-portal-900">
            My Profile
          </span>
        )}
      </div>

      <div className="border-slate-200">
        <div className="m-auto mt-2">
          <div className="">
            <div className="relative flex">
              <img
                className="absolute right-1 hidden lg:block w-5/12"
                src={ill_lothes}
                alt="ill-lothes-hanger-on"
              />

              <div className="w-full lg:w-7/12 z-10">
                {!edit ? (
                  <div className="flex-1">
                    {/* <section>
                      <div className="flex items-center mt-4 mb-6">
                        <div className="mr-4">
                          <img
                            className="w-16 h-16 rounded-full"
                            src={UserAvatar}
                            width="80"
                            height="80"
                            alt="User upload"
                          />
                        </div>
                        <p className="font-medium text-portal-900">
                          {profileData && profileData.username}
                        </p>
                      </div>
                    </section> */}
                    <div className="bg-portal-100 p-10">
                      <div className="w-full mx-auto relative">
                        <EditIcon
                          style="bg-white absolute -right-4 -top-4 z-10"
                          click={editProfile}
                        />
                        <form>
                          <div className="space-y-8">
                            <div>
                              <div className="grid gap-5 md:grid-cols-6">
                                {profileData &&
                                  Object.keys(profileData).map((key, index) => {
                                    return (
                                      <div className={'col-span-3'} key={index}>
                                        <div>
                                          <label
                                            className="block text-sm font-medium mb-1 text-gray-400 capitalize"
                                            htmlFor="default">
                                            {key == 'dob'
                                              ? 'DOB'
                                              : key.replace(/_/g, ' ')}
                                          </label>
                                          <p className="text-black font-medium">
                                            {profileData[key] || '-'}
                                          </p>
                                        </div>
                                      </div>
                                    );
                                  })}
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                ) : (
                  <EditProfile
                    setEdit={() => {
                      setEdit();
                    }}
                  />
                )}
              </div>

              <div
                className="hidden md:block top-0 bottom-0 right-0 lg:w-1/2 py-64"
                aria-hidden="true"></div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Profile;
